'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

require("whatwg-fetch");

var _translate = _interopRequireDefault(require("../translate"));

var _baseForm = _interopRequireDefault(require("./../base-form"));

var _datamasterForms = require("datamaster-forms");

var _formInputs = require("../form-inputs");

var _files = require("../farm/lib/files");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

_es6Promise.default.polyfill();

var StallvisiteForm = /*#__PURE__*/function (_BaseForm) {
  _inherits(StallvisiteForm, _BaseForm);

  function StallvisiteForm(props) {
    var _this;

    _classCallCheck(this, StallvisiteForm);

    _this = _possibleConstructorReturn(this, (StallvisiteForm.__proto__ || Object.getPrototypeOf(StallvisiteForm)).call(this, props));
    _this.state = _lodash.default.extend(_this.state, {
      projectNotFound: props.project ? false : true
    });
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.handleInputRadioBox = _this.handleInputRadioBox.bind(_assertThisInitialized(_this));
    _this.saveStallvisite = _this.saveStallvisite.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   *
   * @returns {*}
   */


  _createClass(StallvisiteForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      if (this.state.projectNotFound) {
        return /*#__PURE__*/_react.default.createElement("p", null, t('Not registered'));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        id: this.props.anchorId || '',
        className: "comp-farm comp-base-form"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: "Stallvisite",
        className: "form-title"
      }, t('Project data')), !_lodash.default.isEmpty(this.props.project) ? /*#__PURE__*/_react.default.createElement(_datamasterForms.ProjectStallvisiteForm, {
        t: t,
        history: this.props.history,
        handleInputChange: this.handleInputChange,
        onChangeAddressType: this.handleInputRadioBox,
        project: this.props.project,
        saveLocationFields: this.saveStallvisite,
        saveOtherFields: this.saveStallvisite,
        fileUploadUrl: "/api/".concat(this.props.i18n.language, "/farms/").concat(this.props.id, "/documents/new"),
        files: this.props.documents,
        onFileRemove: function onFileRemove(file, type) {
          return (0, _files.removeFile)(_this2.props.id, file.id, type, _this2.props.i18n.language).then(function (result) {
            _this2.props.onFileRemove(result.fileId, type);
          });
        },
        onFileUpload: function onFileUpload(file, type) {
          return _this2.props.onFileUploaded(file, type);
        },
        imageUploadUrl: "/api/".concat(this.props.i18n.language, "/farms/").concat(this.props.id, "/images/new"),
        images: this.props.images,
        texts: {
          sectionLocation: {
            sectionTitle: t('datamaster-forms:::stallvisite-section-title-location'),
            save: t('save')
          },
          sectionOther: {
            sectionTitle: t('datamaster-forms:::stallvisite-section-other-title'),
            save: t('save')
          }
        },
        shared: {
          canton: this.props.cantons,
          salutation: this.props.salutations
        },
        addresstype: this.props.addressTypes,
        progress: {
          location: false,
          other: false
        },
        isSaving: {
          location: this.state.isSaving,
          other: this.state.isSaving
        },
        success: {
          location: this.state.success,
          other: this.state.success
        },
        error: {
          location: this.state.form.error,
          other: this.state.form.error
        },
        invalidFields: this.state.form.invalidFields,
        MultiSelectText: _formInputs.AdapterMultiSelect,
        InputRadioGroup: _formInputs.InputRadioGroup,
        InputSelect: _formInputs.AdapterSelect,
        InputField: _formInputs.TextInput,
        InputTextarea: _formInputs.TextareaInput
      }) : null);
    }
    /**
     *
     * @param fieldName
     * @param value
     */

  }, {
    key: "handleInputChange",
    value: function handleInputChange(fieldName, value) {
      var selectFields = {
        canton: 'cantons',
        salutation: 'salutations'
      };

      if (Object.keys(selectFields).includes(fieldName)) {
        value = this.props[selectFields[fieldName]].find(function (selectItem) {
          return parseInt(selectItem.id) === parseInt(value);
        });
      }

      this.props.onProjectDataUpdate(fieldName, value);
    }
    /**
     * @param e
     * @param fieldName
     * @param value
     */

  }, {
    key: "handleInputRadioBox",
    value: function handleInputRadioBox(e, fieldName, value) {
      value = this.props.addressTypes.find(function (addressType) {
        return parseInt(addressType.id) === parseInt(value);
      });
      this.props.onProjectDataUpdate(fieldName, value);
    }
    /**
     *
     * @returns {Promise<Response>}
     */

  }, {
    key: "saveStallvisite",
    value: function saveStallvisite() {
      var _this3 = this;

      this.setState({
        isSaving: true
      });
      this.props.onSaveProject().then(function () {
        _this3.setState(function (prev) {
          prev.form.invalidFields = {
            fields: [],
            details: {}
          }; //Reset general error

          prev.form.error = undefined;
          prev.isSaving = false;
          prev.success = true;
          return prev;
        });
      }).catch(function (error) {
        var message = error.message;
        var invalidFields = {};

        if (error.status === 422) {
          invalidFields = _lodash.default.get(error, 'details.codes');
        }

        _this3.setState(function (prev) {
          prev.error = message;
          prev.form = {
            error: message,
            invalidFields: {
              fields: Object.keys(invalidFields),
              details: invalidFields
            }
          };
          prev.success = false;
          prev.isSaving = false;
          return prev;
        });
      });
    }
  }]);

  return StallvisiteForm;
}(_baseForm.default);

StallvisiteForm.propTypes = {
  t: _propTypes.default.func.isRequired,
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired
  }).isRequired,
  onFileRemove: _propTypes.default.func.isRequired,
  onFileUploaded: _propTypes.default.func.isRequired,
  onSaveProject: _propTypes.default.func.isRequired,
  onProjectDataUpdate: _propTypes.default.func.isRequired,
  cantons: _propTypes.default.array,
  salutations: _propTypes.default.array,
  addressTypes: _propTypes.default.array
};

var _default = (0, _translate.default)(StallvisiteForm);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/stallvisite/stallvisite.js
// module id = 717
// module chunks = 0